import SubmissionsComponent from '../../components/Submissions/Submissions';

function Submissions() {
  return <SubmissionsComponent />;
}

export default Submissions;
